<template>
  <div class="body">
    <div v-show="isMediaPlayerVisible" class="body__player">
      <MediaPlayer ref="mediaPlayer" is-modal-mode @show-list="onShowList" @subject-change="onSubjectChange" />
    </div>
    <div v-show="isPlaylistVisible" class="body__playlist">
      <div v-show="modalSectionSelected === 2" style="height: 100%">
        <MyPlaylist @back="onBack" />
      </div>
      <div v-show="modalSectionSelected !== 2">
        <Playlist
          v-show="!isAdvancedFilterVisible"
          :subject="subjectInfo"
          @back="onBack"
          @click-open-modes="onClickOpenModes"
          @click-advanced-filter="onClickAdvancedFilter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/event-bus';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'Body',
  components: {
    MediaPlayer: () => import('@/components/Sections/MediaPlayer-v3/Main'),
    Playlist: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/Playlist'),
    MyPlaylist: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/MyPlaylist'),
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isListVisible: false,
      subjectInfo: '',
      isAdvancedFilterVisible: false,
    };
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('mediaModal', ['modalSectionSelected']),
    isPlaylistVisible() {
      return !this.isMobile ? true : this.isListVisible;
    },
    isMediaPlayerVisible() {
      return !this.isMobile ? true : !this.isListVisible;
    },
  },
  watch: {
    modalSectionSelected(newValue) {
      if (newValue !== 2) {
        this.isAdvancedFilterVisible = false;
      }
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setAdvancedFilterBackUp', 'restoreAdvancedFilterFromBackUp']),
    beforeClose() {
      this.$refs.mediaPlayer.setUpMediaGeneralData();
    },
    onSubjectChange(subject) {
      this.subjectInfo = subject;
    },
    onShowList() {
      this.isListVisible = true;
    },
    onBack() {
      this.isListVisible = false;
    },
    onClickOpenModes() {
      if (this.isMobile && this.isListVisible) {
        this.isListVisible = false;
      }
      this.$refs.mediaPlayer.onClickOpenModes();
    },
    onClickAdvancedFilter() {
      this.setAdvancedFilterBackUp();
      this.isAdvancedFilterVisible = true;
    },
    onCancel() {
      this.restoreAdvancedFilterFromBackUp();
      this.onClose();
    },
    onClose() {
      this.isAdvancedFilterVisible = false;
    },
  },
  created() {
    EventBus.$on('play-video', this.checkWidth);
    EventBus.$on('click-play', this.checkWidth);
  },
};
</script>

<style scoped lang="scss">
.body {
  font-size: 1rem;
  display: grid;
  grid-template-columns: 58% 39%;
  column-gap: 3%;

  @media screen and (max-width: 1345px) {
    grid-template-columns: 1fr;
    row-gap: 2em;
  }
}
</style>
